import { useSelector } from "react-redux";

import { Card, CardContent } from "@mui/material";

import { FrmSelectFromObjects } from "components/formFields/FrmSelectFromObjects";
import { LocationToggle } from "components/formFields/address/LocationToggle";
import { CardHeader } from "components/formFields/formCards/CardHeader";

import { i18n } from "services/i18nService";

import { useRelated } from "hooks/useRelated";

export function ShippingAddress(props) {
  const { value, handleInputFieldChange, location, customer, isDropShip } =
    props;

  const findCustomerByFullName = useSelector(
    (state) => state.userCompanySettings.settings.findCustomerByFullName
  );

  const customers = useRelated("customer");
  const locations = useRelated("location");

  function getCustomerOption() {
    if (!customer) {
      return null;
    }
    const matchedCustomer = customers?.find(({ id }) => id === customer.id);
    return matchedCustomer ?? customer ?? null;
  }

  return (
    <Card variant="outlined" data-testing="shipping">
      <CardContent>
        <div style={{ display: "flex", alignItems: "center" }}>
          <CardHeader
            text={i18n("purchaseOrder.ShippingAddress")}
            gutterBottom={false}
          />
          <div style={{ flexGrow: 1, paddingLeft: "1rem" }}>
            {isDropShip ? (
              <FrmSelectFromObjects
                key="customer"
                name="customer"
                optionDisplayText={findCustomerByFullName ? "fullname" : "name"}
                label={i18n("global.Customer")}
                value={getCustomerOption()}
                onValueChange={handleInputFieldChange}
                options={customers}
              />
            ) : (
              <FrmSelectFromObjects
                key="location"
                name="location"
                label={i18n("global.Location")}
                value={location?.id ? location : null}
                onValueChange={handleInputFieldChange}
                options={locations}
              />
            )}
          </div>
        </div>
        <LocationToggle
          value={value}
          addressType="shipping"
          handleInputFieldChange={handleInputFieldChange}
        />
      </CardContent>
    </Card>
  );
}
